import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { CoreToasterProvider } from '@amzn/dots-core-ui';
import Home from './Home';
import { ConfigurationList } from './Configurations';
import { PackageDetail } from './Packages';
import { PlanDetail, PlanList } from './Plans';
import { rootPath } from './routes';

export type AppRouterProps = {
  isRootApp: boolean;
};

const AppRouter = ({ isRootApp }: AppRouterProps): JSX.Element => {
  return (
    <CoreToasterProvider>
      <Switch>
        <Route path={`${rootPath}/packages/:id`}>
          <PackageDetail />
        </Route>
        <Route path={`${rootPath}/packages`}>
          <ConfigurationList
            key="packages-list"
            title="Test Suites"
            packageType="test"
          />
        </Route>
        <Route path={`${rootPath}/resources/:id`}>
          <PackageDetail />
        </Route>
        <Route path={`${rootPath}/resources`}>
          <ConfigurationList
            key="resources-list"
            title="Resources"
            packageType="resource"
          />
        </Route>
        <Route path={`${rootPath}/handlers/:id`}>
          <PackageDetail />
        </Route>
        <Route path={`${rootPath}/handlers`}>
          <ConfigurationList
            key="handlers-list"
            title="Handlers"
            packageType="handler"
          />
        </Route>
        <Route path={`${rootPath}/plans/:id`}>
          <PlanDetail />
        </Route>
        <Route path={`${rootPath}/plans`}>
          <PlanList />
        </Route>
        <Route path={rootPath} component={Home} />
        {isRootApp && <Redirect to={rootPath} />}
      </Switch>
    </CoreToasterProvider>
  );
};

export default AppRouter;
